// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"aefb0ca7","324":"3de19b68","475":"55aae9c5","795":"199cf4c2"}[chunkId] + ".chunk.js";
};